import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { WifiOff, RefreshCw } from 'lucide-react';

export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      if (wasOffline) {
        // Show reconnected briefly
        setTimeout(() => setWasOffline(false), 3000);
      }
    };

    const handleOffline = () => {
      setIsOffline(true);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  return (
    <AnimatePresence>
      {isOffline && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ type: 'spring', damping: 20 }}
          className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950"
        >
          <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-3">
            <WifiOff size={18} />
            <span className="text-sm font-medium">
              You're offline. Changes will be saved locally.
            </span>
            <button
              onClick={() => window.location.reload()}
              className="p-1 rounded hover:bg-amber-600/30 transition-colors"
              title="Retry connection"
            >
              <RefreshCw size={16} />
            </button>
          </div>
        </motion.div>
      )}

      {!isOffline && wasOffline && (
        <motion.div
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -100, opacity: 0 }}
          transition={{ type: 'spring', damping: 20 }}
          className="fixed top-0 left-0 right-0 z-[100] beacon-sweep bg-[#5EEAD4] text-[#071512]"
        >
          <div className="container mx-auto px-4 py-2 flex items-center justify-center gap-3">
            <span className="text-sm font-medium">
              Back online! Your changes are being synced.
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
